var map = {
	"./default.png": 2889,
	"./diali.png": 91977,
	"./game2.png": 81934,
	"./gdcd.png": 34288,
	"./hoahoc.png": 45138,
	"./hoahoc1.png": 40593,
	"./hoahoc2.png": 19482,
	"./khac.png": 54725,
	"./khtn.png": 45699,
	"./lichsu.png": 19612,
	"./lichsu1.png": 84431,
	"./nguvan.png": 38013,
	"./nguvan1.png": 29472,
	"./nguvan2.png": 91451,
	"./nguvan_temp.png": 22168,
	"./sinhhoc.png": 73614,
	"./sinhhoc1.png": 83957,
	"./sinhhoc2.png": 98206,
	"./tienganh.png": 40026,
	"./tienganh1.png": 84969,
	"./tienganh2.png": 20434,
	"./tiengnga.png": 5831,
	"./tiengnga1.png": 23358,
	"./tiengnga2.png": 9109,
	"./tiengnhat.png": 45327,
	"./tiengnhat1.png": 40079,
	"./tiengnhat2.png": 1268,
	"./tiengphap.png": 39254,
	"./tiengtq.png": 67428,
	"./tiengtq1.png": 40167,
	"./tiengtq2.png": 89484,
	"./tiengviet.png": 48453,
	"./tiengviet1.png": 93688,
	"./tiengviet2.png": 39443,
	"./tiengviet_temp.png": 70192,
	"./toan.png": 64394,
	"./toan1.png": 66105,
	"./toan2.png": 10018,
	"./vatli.png": 15682,
	"./vatli1.png": 95489,
	"./vatli2.png": 46506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84199;